(function () {
    'use strict';
    angular
        .module('ActionManager')
        .factory('action-scroll-to', actionFunc);

    function actionFunc(lodash, $timeout) {
        return function (options) {
            return $timeout(function() {
                var container = lodash.get(options, 'container', 'body');
                var scrollToClass = lodash.get(options, 'scrollTo', '.error, .sub-form-row-error');;
                var animateOffset = lodash.get(options, 'offset', 50);
                angular.element(container).animate({
                    scrollTop: angular.element(scrollToClass).offset().top - animateOffset
                }, 500);
            });
        };
    }
})();
